

export const timeParsingFunc = (stamp: any, duration: any, recent:boolean) => {
  if (stamp === undefined) return "";
  try {
    // let sTime = timesta(stamp);
    let sTime;

    var today = new Date(stamp);
    let hours: number = Math.floor(duration / 60);
    let minutes: number = Math.floor(duration % 60);

    if (hours !== 0) { today.setHours(today.getHours() + hours); }
    if (minutes !== 0) { today.setMinutes(today.getMinutes() + minutes); }

    // let eTime = timeCalculate(today.getTime());
    let eTime;
    if(recent)
    {
      return sTime + " - " + eTime;
    }
    else{
      return sTime + " To " + eTime;
    }
  }
  catch (error) {
    return "";
  }
};


export const copyTemplate = (element: any) => {

  let getSelection: any = window.getSelection();
  getSelection.removeAllRanges();
  let range = document.createRange();
  range.selectNode(typeof element === 'string' ? document.getElementById(element) : element);
  getSelection.addRange(range);
  document.execCommand('copy');
  getSelection.removeAllRanges();
};